
// for socket.io
import socketIOClient from "socket.io-client";
import DeviceService from '@user-service//DeviceService';
import AuthProvider from '@user-provider/AuthProvider'
import Axios from 'axios';
import BridgeProvider from "./BridgeProvider";
import NetworkHelper from "../helper/NetworkHelper";
import GlobalAlertProvider from "./GlobalAlertProvider";
import { showSnackbar, closeSnackbar } from "@helper/SnackbarHelper";

const zlib = require('zlib');

export default class SocketProvider {

    static socket
    static deviceInfo       //기기 정보

    static onConnect        //서버와 연결
    static onDisconnect     //서버와 종료

    static onMeasure        //측정중- 데이터 받음

    static onMeasureMonitor
    static onMeasureHit
    static onMeasureTime

    static onMeasureStart   //측정 시작
    static onMeasureStop    //측정 종료

    static onMeasureStartStatusBar
    static onMeasureStopStatusBar

    static onMeasureStopByAutoRun // 자동 시작시
    static onDeviceDisconnect   //브레인헬스 기기와 연결이 끊어짐
    static onDeviceStatus

    static onMessages

    static recvData = [] // 서버에서 받은데이터
    static localMode = false        // 로컬-우선 경로 사용 중 (스펙 §4.5)
    static localSessionId = null    // 로컬 세션 ID (서버 FILE_KEY)
    static _localStartResolve = null
    static _localStartReject = null
    static recvDataCount = 0  //서버에서 보낸 측정휫수 
    static recvDate;

    static sendData = []
    static sendDataCount = 0
    static eventWorker  // 서버에서 받은 데이터를 1초 마다 처리하기 위한 worker 
    static sendWorker

    static requestMeasure    // 측정 요청 파라미터
    static startCheckTimer          //시작 측정 여부 확  

    static fileKey
    static measureLogID

    static isBRHWService = false
    static isRunning = false
    static hasConnected = false          // 최초 연결 완료 여부
    static pause = false
    static measureHzType

    static useEndMeasureOfQueue = false
    static currentTime = 0

    // [PERF] 1초 처리 진단 통계 (배포 후 CDP 콘솔에서 window.__brhwPerf 로 확인)
    //  send/recv/tick: 간격(ms) 누적, backlogMax: 큐 최대 적체, drainedMax: 한 틱에 소진한 최대 프레임 수,
    //  remainNonZero: 틱 종료 시 잔여가 남은 횟수(계속 증가하면 소비가 생산을 못 따라가는 것)
    static perf = SocketProvider.perfReset()

    static perfReset(){
        const stat = () => ({ n: 0, sum: 0, max: 0, last: 0 })
        const p = {
            startedAt: Date.now(),
            send: stat(), recv: stat(), tick: stat(), onMeasure: stat(),
            sendBacklogMax: 0, recvBacklogMax: 0, drainedMax: 0, remainMax: 0, remainNonZero: 0, frames: 0,
        }
        try { window.__brhwPerf = p } catch(e) {}
        return p
    }

    static perfAdd(stat, v){
        stat.n++; stat.sum += v; stat.last = v
        if(v > stat.max) stat.max = v
    }

    // 누적 시간 관리
    static targetMeasureTime = 0        // 목표 측정 시간 (원래 요청 시간, DB 저장용)
    static deviceMeasureTime = 0        // 기기에 보내는 측정 시간 (목표 + 50% 여유)
    static accumulatedTime = 0          // 누적 측정 시간
    static lastMeasuredTime = 0         // 마지막 측정된 시간 (setStopStatus 영향 안받음)
    static isRetryMeasure = false       // 추가 측정 중 여부
    static onAutoRetryMeasure = null    // 추가 측정 시작 콜백

    static serialportLogs = []          // 시리얼포트 로그 저장
    static onSerialportLog = null       // 시리얼포트 로그 수신 콜백 (UI 업데이트용)

    static onDeviceMeasureDataConsole
    /**
     * 기기에서 보내는 이벤트 관련
     */
    static async initDeviceEvent(window){
        if(window && !window.app){
            window.app = {}
        }
        
        try {
          window.app.onDeviceMeasureData = null
          window.app.onDeviceMeasureDataUNC = null
          window.app.onDeviceMeasureStop = null
          window.app.onPacketError = null
          window.app.onMeasureError = null
          window.app.serialportLog = null
        } catch (e) {
          console.warn('[SocketProvider] initDeviceEvent clear failed:', e)
        }

        try {
            window.app.onDeviceMeasureData = (data) => {
                this.onDeviceMeasureData(data) 
            }
            window.app.onDeviceMeasureDataUNC = (data) => {
                const enc = NetworkHelper.getEncParam(JSON.parse(data))
                this.onDeviceMeasureData(enc)
            }
            
            window.app.onDeviceMeasureStop = () => { this.onDeviceMeasureStop() }
            window.app.onPacketError = () => {}

            // ---- 로컬-우선 측정 (스펙 §4.5): C#(DLL) 계산 결과를 기존 measure-queue 와
            //      동일한 페이로드로 공유 큐(recvData)에 주입 → 모든 페이지 무변경 렌더 ----
            window.app.onLocalMeasureData = (parsedData) => {
                try {
                    const obj = ('string' === typeof parsedData) ? JSON.parse(parsedData) : parsedData
                    const data = zlib.deflateSync(Buffer.from(JSON.stringify(obj))).toString('base64')
                    this.recvData.push({ action: 'measure', data })
                    this.recvDataCount++
                } catch (e) {
                    console.error('[SocketProvider] onLocalMeasureData failed:', e)
                }
            }
            window.app.onLocalMeasureStarted = (sessionId) => {
                console.log('[SocketProvider] local measure started:', sessionId)
                this.localSessionId = sessionId
                try { this._localStartResolve && this._localStartResolve(sessionId) } catch (e) {}
            }
            window.app.onLocalMeasureFailed = (message) => {
                console.error('[SocketProvider] local measure failed → 소켓 경로 폴백:', message)
                this.localSessionId = null
                try { this._localStartReject && this._localStartReject(message) } catch (e) {}
                try { this.onLocalMeasureFallback && this.onLocalMeasureFallback(message) } catch (e) {}
            }

            // Windows 앱에서 측정 시작 실패 등의 에러 메시지를 받아서 글로벌 다이얼로그로 표시
            window.app.onMeasureError = (message) => {
                console.error('[SocketProvider] onMeasureError from device:', message)
                this.addSerialportLog('[오류] ' + message)
                GlobalAlertProvider.show(message, '측정 오류')
            }

            // Windows 앱에서 시리얼포트 연결 에러/로그를 실시간으로 받음
            window.app.serialportLog = (message) => {
                console.warn('[SocketProvider] serialportLog from device:', message)
                this.addSerialportLog(message)
            }

            /*
               안드로이드 이벤트 처리
             */
            window.app.onDeviceInfo = (deviceInfo) => {
                BridgeProvider.instance.resolve(deviceInfo)
            }
            window.app.onVersion = (version) => { BridgeProvider.instance.resolve(version) }
            window.app.onOsVersion = (version) => { BridgeProvider.instance.resolve(version) }
            window.app.onConnectedDevice =(isConnected) => { BridgeProvider.instance.resolve(isConnected)}

        } catch (e) {
            console.error('[SocketProvider] initDeviceEvent setup failed:', e)
        }

        this.isBRHWService = BridgeProvider.isBRHWService
    }

    /**
     * 기기에서 받은 데이터를 서버로 전송합니다.
     * @param data
     */
    static onDeviceMeasureData(data){
        this.sendDataCount++
        this.sendData.push({
            action: 'measure',
            data
        });
    }

    /**
     * stop from client
     * @returns {Promise<void>}
     */
    static async onDeviceMeasureStop(){
        // 로컬-우선 경로: 서버 전송 큐(sendWorker)가 없으므로 직접 종료 처리.
        // (C# 이 세션 완료/업로드를 담당, 웹은 종료 통지만 필요 — 스펙 §4.5 파리티)
        if(this.localMode){
            this.measureStop().then()
            return
        }
        this.sendData.push({
            action: 'stop',
        })
    }

    /**
     * sender queue worker
     */
    static startSendWorker() {
        this.clearSendWork()

        this.sendWorker = setInterval(() => {
            const queue = this.sendData.shift()

            if(!queue) return
            
            if(this.socket.connected){
                this.socket.emit('measure-queue', queue)
                // [PERF] 송신: 큐를 서버로 내보낸 시점 + 아직 밀려있는 송신 백로그
                if(queue.action === 'measure'){
                    const _now = Date.now()
                    const _sendGap = _now - (this._perfLastSend || _now)
                    this._perfLastSend = _now
                    if(this.perf.send.n > 0 || _sendGap > 0) this.perfAdd(this.perf.send, _sendGap)
                    if(this.sendData.length > this.perf.sendBacklogMax) this.perf.sendBacklogMax = this.sendData.length
                    console.log(`[PERF][send] sendGap=${_sendGap}ms sendBacklog=${this.sendData.length}`)
                }
            } else {
                this.sendData.unshift(queue)
            }

        }, 300)
    }


    /**
     * clear sender worker
     */
    static clearSendWork(){
        if(this.sendWorker) {
            clearInterval(this.sendWorker)
        }

        this.sendData.length = 0
    }

    /**
     * parse received Data
     * @returns {boolean}
     */
    static parseReceivedData(){

        // [PERF] 소비 워커 진단: 이 콜백이 실제로 불린 간격 (빈 틱 포함해 타이머 밀림을 잡는다)
        const _perfNow = Date.now()
        const _tickGap = _perfNow - (this._perfLastTick || _perfNow)
        this._perfLastTick = _perfNow
        if(_tickGap > 0) this.perfAdd(this.perf.tick, _tickGap)

        if(this.pause) { return false }
        if(0 === this.recvData.length) { return false }

        // 캐치업: 틱이 밀려 쌓인 프레임을 이번 틱에 모두 소진한다.
        //  (기존엔 틱당 1개만 꺼내 저사양에서 영구히 뒤처졌음 → 버퍼 누적·시간 지연)
        //  화면의 "초"는 프레임에 실려온 parsedData.time(기기 인덱스)이라, 다 흘려도 초는 기기 리듬(1초/프레임)을 따른다.
        const _backlogAtTick = this.recvData.length
        let _drained = 0

        while(this.recvData.length > 0){
            if(this.pause) break

            const queueData = this.recvData.shift()
            if(!queueData) break

            let stop = false
            try {
                stop = this.consumeReceived(queueData)
            } catch(e){ console.log(e) }

            _drained++
            if(stop) break   // 'stop'/종료 처리 시 워커가 재시작·종료되므로 드레인 중단
        }

        // [PERF] 틱 요약 — drained>1 이면 밀렸다가 이번 틱에 따라잡은 것, remain>0 이 계속되면 렌더가 생산을 못 따라감
        if(_backlogAtTick > this.perf.recvBacklogMax) this.perf.recvBacklogMax = _backlogAtTick
        if(_drained > this.perf.drainedMax) this.perf.drainedMax = _drained
        if(this.recvData.length > this.perf.remainMax) this.perf.remainMax = this.recvData.length
        if(this.recvData.length > 0) this.perf.remainNonZero++
        console.log(`[PERF][consume] tickGap=${_tickGap}ms backlogAtTick=${_backlogAtTick} drained=${_drained} remain=${this.recvData.length}`)
    }

    /**
     * 수신 큐 1건 처리.
     * @returns {boolean} true 이면 드레인 중단(측정 종료/재시작이 트리거됨)
     */
    static consumeReceived(queueData){
        const { data , action } = queueData

        switch (action){
            case 'measure': {
                const jsonString = zlib.inflateSync(Buffer.from(data, 'base64')).toString()
                const parsedData = JSON.parse(jsonString)

                if(parsedData.hzType !== this.measureHzType) return false
                if(!this.onMeasure || !parsedData) return false
                if(this.currentTime === parsedData.time) return false  // 중복 프레임 skip

                // [PERF] 렌더 콜백(onMeasure = 레이더 렌더 + 히트 사운드) 소요 시간
                const _onMeasureStart = Date.now()
                this.onMeasure(parsedData)
                const _onMeasureCost = Date.now() - _onMeasureStart
                this.perfAdd(this.perf.onMeasure, _onMeasureCost)
                this.perf.frames++

                const totalTime = this.accumulatedTime + parsedData.time
                console.log(`[SocketProvider] onData - 현재: ${parsedData.time}초, 누적: ${totalTime}초 / 목표: ${this.targetMeasureTime}초 (onMeasureCost=${_onMeasureCost}ms)`)

                try { this.onMeasureHit(parsedData.isHit) } catch{}
                try { this.onMeasureMonitor(parsedData) } catch{}

                // 항상 마지막 측정 시간 저장
                this.currentTime = parsedData.time
                this.lastMeasuredTime = parsedData.time

                if(this.onMeasureTime){
                    this.onMeasureTime(parsedData.time)
                }

                // 누적 시간이 목표에 도달하면 React에서 직접 종료
                if(this.targetMeasureTime > 0 && totalTime >= this.targetMeasureTime){
                    console.log(`[SocketProvider] 목표 시간 도달 - 누적: ${totalTime}초 / 목표: ${this.targetMeasureTime}초, 종료 처리`)
                    this.onDeviceMeasureStop()
                    return true
                }
                return false
            }
            case 'stop': {
                // 누적 시간 업데이트 (measure-queue로 stop이 온 경우)
                this.accumulatedTime += this.lastMeasuredTime
                console.log(`[SocketProvider] stop action - lastMeasuredTime: ${this.lastMeasuredTime}, accumulated: ${this.accumulatedTime}, target: ${this.targetMeasureTime}`)

                const remainingTime = this.targetMeasureTime - this.accumulatedTime
                if(remainingTime > 1 && !this.isRetryMeasure) {
                    console.log(`[SocketProvider] 부족한 시간 ${remainingTime}초 - 추가 측정 시작 (fileKey 유지: ${this.fileKey})`)
                    this.isRetryMeasure = true
                    this.lastMeasuredTime = 0

                    // 기기에 직접 측정 시작 메시지 전송 (기존 fileKey 유지, 여유시간 적용)
                    try {
                        const deviceRemaining = Math.ceil(remainingTime * 1.5)
                        this.deviceMeasureTime = deviceRemaining
                        BridgeProvider.instance.deviceMeasureStart(deviceRemaining, this.requestMeasure.measureType).then()
                    } catch(e) {
                        console.error('[SocketProvider] 추가 측정 기기 시작 실패:', e)
                    }

                    // worker 재시작 (새로운 measure-start 없이 기존 세션 유지)
                    this.startSendWorker()
                    this.startEventWorker()

                    // 콜백 호출 (UI 업데이트용)
                    if(this.onAutoRetryMeasure) {
                        this.onAutoRetryMeasure(remainingTime)
                    }
                } else {
                    this.measureStop().then()
                }
                return true
            }
            default:
                return false
        }
    }
    /**
     * 로컬-우선 경로 사용 가능 여부 (스펙 §7 킬스위치).
     * 신버전 exe(getCapabilities 존재) + 서버 LOCAL_FIRST_HZ_TYPE 에 hzType 포함('all'=전체 허용)일 때만 true.
     * 어떤 실패든 false → 기존 소켓 경로(안전 기본값).
     */
    /**
     * 소켓/측정 서버 호스트 해석 — connect() 와 동일 규칙.
     * dev: /api/host-ip(API 서버가 자기 IP 반환) 우선 → 실패 시 REACT_APP_DEV_SOCKET_HOST → prod env.
     */
    static async resolveSocketHost() {
        let socketHost = process.env.REACT_APP_SOCKET_HOST
        if ('development' === process.env.NODE_ENV) {
            try {
                const res = await Axios.get(`/api/host-ip`)
                socketHost = `${res.data}:4001`
            } catch (e) {
                if (process.env.REACT_APP_DEV_SOCKET_HOST) socketHost = process.env.REACT_APP_DEV_SOCKET_HOST
            }
        }
        return socketHost
    }

    static async canUseLocalFirst(hzType) {
        try {
            if (!window.BRHW || !window.BRHW.getCapabilities) return false
            const capsRaw = await window.BRHW.getCapabilities()
            const caps = ('string' === typeof capsRaw) ? JSON.parse(capsRaw) : capsRaw
            if (!caps || !caps.localRecord) return false

            const socketHost = await this.resolveSocketHost()
            const res = await fetch(socketHost + '/measure/config')
            const cfg = await res.json()
            // 서버는 배열(JSON)로 반환한다. 구버전 문자열 응답도 함께 수용.
            // 'all' 은 와일드카드 — 모든 hzType 이 로컬-우선 대상.
            const rawList = cfg.localFirstHzType || []
            const list = (Array.isArray(rawList) ? rawList : String(rawList).split(','))
                .map((s) => String(s).trim()).filter(Boolean)
            return -1 < list.indexOf('all') || -1 < list.indexOf(hzType)
        } catch (e) {
            console.warn('[SocketProvider] canUseLocalFirst → 소켓 경로 폴백:', e)
            return false
        }
    }

    /**
     * 로컬-우선 측정 시작: C# 브릿지에 메타(serverBaseUrl 포함) 전달.
     * onLocalMeasureStarted/Failed 콜백을 promise 로 대기(10초 타임아웃).
     * 결과는 onLocalMeasureData 로 공유 큐에 주입되어 기존 소비자가 그대로 처리한다.
     */
    static async startLocalMeasure(meta) {
        const socketHost = await this.resolveSocketHost()
        const payload = Object.assign({ serverBaseUrl: socketHost }, meta)
        return new Promise((resolve, reject) => {
            const timeout = setTimeout(() => { cleanup(); reject(new Error('LOCAL_START_TIMEOUT')) }, 10000)
            const cleanup = () => {
                clearTimeout(timeout)
                this._localStartResolve = null
                this._localStartReject = null
            }
            this._localStartResolve = (sessionId) => { cleanup(); resolve(sessionId) }
            this._localStartReject = (message) => { cleanup(); reject(new Error(message)) }
            try { window.BRHW.startLocalMeasure(JSON.stringify(payload)) }
            catch (e) { cleanup(); reject(e) }
        })
    }

    static async stopLocalMeasure() {
        try { return window.BRHW.stopLocalMeasure() } catch (e) {}
    }

    /**
     * start received data worker
     */
    static startEventWorker() {
        this.clearEventWorker()
        // 250ms 폴링 + 매 틱 백로그 전부 드레인(parseReceivedData).
        //  - 짧은 주기 → 도착 후 소비까지 추가 지연 ≤250ms (기존 1000ms 대비 감소)
        //  - 드레인-올 → 틱이 밀려도 다음 틱에 즉시 캐치업, 버퍼가 누적되지 않음
        //  화면 "초"는 프레임의 parsedData.time(기기 1초 리듬)이라 폴링을 빠르게 해도 초가 빨라지지 않는다.
        this.eventWorker = setInterval(this.parseReceivedData.bind(this), 250)
    }

    static clearEventWorker() {
        if(this.eventWorker) {
            clearInterval(this.eventWorker)
            this.eventWorker = null
        }
    }
    /**
     * get status from redis db
     * @returns {Promise<*>}
     */
    static async checkDeviceStatus(){
        const info = {
            memberID: '',
            token: '',
            mac: '',
        }

        if(AuthProvider.isCustomerView()){
            info.memberID = AuthProvider.getCustomerMemberID()
            info.token = AuthProvider.getToken()
            info.mac = AuthProvider.get('computerMac')
        } else {
            try {
                // const deviceInfo = await window.BRHW.getDeviceInfo()
                const deviceInfo = await BridgeProvider.instance.getDeviceInfo()
                const urlParams = new URLSearchParams(deviceInfo)

                info.token = urlParams.get('token')
                info.mac =  urlParams.get('mac')

            } catch (e) {
                console.error('[SocketProvider] checkDeviceStatus getDeviceInfo failed:', e)
            }
        }
        if('' === info.token && '' === info.memberID ){
            return null
        }

        const { data } = await DeviceService.connected(info);
        return data
    }
  
    static async applyGlobalConfig(){
      this.socket.emit('load-global-config')
    }
    
    /**
     * start measure to socket with device
     * @param measureTime
     * @param prescriptionID
     * @param hzType
     * @param measureType
     * @param measureTypeCode
     * @param measureCode
     * @param checkStartCallback
     * @param startCallback
     * @param stepCount
     * @param noiseCode
     * @returns {Promise<boolean>}
     */
    static async measureStart(
        measureTime,
        prescriptionID,
        hzType = 'default',
        measureType,
        measureTypeCode,
        measureCode = 'C',
        checkStartCallback = null,
        startCallback = null,
        stepCount = 1,
        noiseCode = 'A') {

        if(this.isRunning) { return false }
        if(!this.socket) { return false }

        this.setStopStatus()

        // 추가 측정이 아닐 때만 누적 시간 초기화
        if(!this.isRetryMeasure) {
            this.targetMeasureTime = parseInt(measureTime)
            this.deviceMeasureTime = Math.ceil(this.targetMeasureTime * 1.5)
            this.accumulatedTime = 0
            this.lastMeasuredTime = 0
            // 이전 측정의 retry 상태가 남아있을 수 있으므로 초기화
            this.isRetryMeasure = false
            // [PERF] 측정 단위로 1초 처리 통계 초기화 (window.__brhwPerf)
            this.perf = this.perfReset()
            this._perfLastSend = this._perfLastRecv = this._perfLastTick = 0
            console.log(`[SocketProvider] 측정 시작 - 목표: ${this.targetMeasureTime}초, 기기전달: ${this.deviceMeasureTime}초, isRetry: false`)
        } else {
            this.lastMeasuredTime = 0  // 추가 측정도 새로 시작하므로 초기화
            console.log(`[SocketProvider] 추가 측정 시작 - 요청시간: ${measureTime}초, accumulated: ${this.accumulatedTime}, target: ${this.targetMeasureTime}`)
        }

        try {

            this.requestMeasure = {
                profileID: AuthProvider.getProfileID(),
                measureBit: 256,
                measureTime: parseInt(measureTime),
                prescriptionID,
                measureType,
                measureTypeCode,
                measureCode,
                hzType,
                stepCount,
                deviceSerial: this.deviceInfo.deviceSerial,
                noiseCode: noiseCode
            }

            if(!this.isBRHWService){
                this.addSerialportLog('[오류] 기기와 연결되지 않았습니다. (기기 서비스 미연결)')
                GlobalAlertProvider.show('기기와 연결되지 않았습니다.', '연결 오류')
                if(startCallback) {
                    startCallback(false)
                }
                return false
            }

            // ---- 로컬-우선 경로 (스펙 §7): 신버전 exe + 킬스위치 on 이면
            //      소켓 emit 대신 C#(DLL) 로컬 측정. 실패 시 아래 기존 소켓 경로로 폴백. ----
            if (await this.canUseLocalFirst(hzType)) {
                try {
                    const sessionId = await this.startLocalMeasure({
                        deviceSerial: this.deviceInfo.deviceSerial,
                        deviceID: this.deviceInfo.deviceID,
                        profileID: AuthProvider.getProfileID(),
                        prescriptionID, hzType, measureType, measureTypeCode, measureCode,
                        measureTime: parseInt(measureTime),
                        noiseCode,
                    })
                    this.localMode = true
                    this.fileKey = sessionId          // 서버 FILE_KEY = sessionId (업로드 후 동일 키)
                    this.startEventWorker()           // 큐 소비자 — 렌더 경로는 소켓과 동일
                    this.isRunning = true
                    console.log(`[SocketProvider] 로컬-우선 측정 시작 - session: ${sessionId}`)
                    if (this.onMeasureStartStatusBar) { this.onMeasureStartStatusBar(this.requestMeasure) }
                    if (checkStartCallback) { checkStartCallback() }
                    if (startCallback) { startCallback(true) }
                    return true
                } catch (e) {
                    this.localMode = false
                    this.addSerialportLog('[안내] 로컬 측정 시작 실패, 소켓 경로로 폴백: ' + (e.message || e))
                    console.warn('[SocketProvider] local-first fallback:', e)
                }
            }

            this.startSendWorker()
            this.startEventWorker()
            this.setMeasureOption()

            this.socket.emit('measure-start',
                this.requestMeasure,
                ({success, message, fileKey, logID}) => {
                    this.fileKey = fileKey
                    this.measureLogID = logID

                    if (!success) {
                        if('EMPTY_HZ_SETTINGS' === message){
                            this.addSerialportLog('[오류] 측정 시작 실패: 주파수 설정값 없음')
                            GlobalAlertProvider.show('측정 시작에 실패했습니다. 설정값을 확인해주세요', '측정 오류')
                        } else if ('NOT_CONNECTED_DEVICE' === message){
                            this.addSerialportLog('[오류] 측정 시작 실패: 기기 미연결')
                            GlobalAlertProvider.show('기기와 연결되지 않았습니다. 연결을 확인해 주세요', '연결 오류')
                        }
                    } else {
                        this.isRunning = true

                        try {
                            // 기기에는 여유시간(+50%)이 적용된 시간을 전달
                            BridgeProvider.instance.deviceMeasureStart(this.deviceMeasureTime, measureType).then()

                            if(this.onMeasureStartStatusBar){
                                this.onMeasureStartStatusBar(this.requestMeasure)
                            }
                        } catch(e){
                            this.socket.emit('measure-start-failed', {
                                logID,
                                message: '[E_ST_0001] 측정시작실패'
                            })

                            this.clearSendWork()
                            // this.clearEventWorker()

                            this.addSerialportLog('[오류] 기기 측정 시작 실패: ' + (e.message || e))
                            GlobalAlertProvider.show('측정 시작에 실패했습니다. 다시 시도해 주세요', '측정 오류')
                            this.isRunning = false
                        }
                    }

                    if(startCallback){
                        startCallback(success)
                    }
                })
        }catch(e){
            this.addSerialportLog('[오류] 측정 시작 예외: ' + (e.message || e))
            GlobalAlertProvider.show('측정 시작에 실패했습니다', '측정 오류')
        }
    }
    /**
     * toggle device data
     * @returns {Promise<boolean>}
     */
    static async measurePauseToggle(){
        if(this.pause){
            try {
                this.pause = false
                await BridgeProvider.instance.deviceMeasureResume()
                // await window.BRHW.deviceMeasureResume()
            } catch (e) {
                console.error('[SocketProvider] deviceMeasureResume failed:', e)
            }
            return this.pause
        }

        try {
            if(this.isRunning){
                this.pause = true
                // await window.BRHW.deviceMeasurePause()
                await BridgeProvider.instance.deviceMeasurePause()
            }
        } catch (e) {
            console.error('[SocketProvider] deviceMeasurePause failed:', e)
        }

        return this.pause
    }

    /**
     * measure stop to device
     * @param withClearEvent
     * @param force
     * @returns {Promise<boolean>}
     */
    static async measureStop(withClearEvent = false, force= false){
        this.setStopStatus()

        if(withClearEvent){
            this.clearEvent()
        }

        if(!this.isBRHWService){
            return false
        }

        // 로컬-우선 경로: C# 이 시리얼 정지 + 세션 완료(SQLite) + 업로드 트리거까지 처리
        if(this.localMode){
            // 재진입 가드: 목표 도달(웹)과 기기 정지 통지(C#)가 동시에 들어와도 1회만 종료 처리
            this.localMode = false
            try { await this.stopLocalMeasure() } catch(e) {}
            this.clearEventWorker()
            this.isRunning = false
            console.log(`[SocketProvider] 로컬-우선 측정 종료 - session: ${this.localSessionId}`)

            // 서버 'measure-stop' 소켓 이벤트와 동일한 종료 통지 — 페이지(onMeasureStop)가
            // 완료 다이얼로그/이동을 처리한다. fileKey = 로컬 sessionId (서버 FILE_KEY 동일).
            this.isRetryMeasure = false
            this.accumulatedTime = 0
            this.lastMeasuredTime = 0
            const data = { fileKey: this.fileKey, force }
            if(this.onMeasureStop) this.onMeasureStop(data)
            if(this.onMeasureStopByAutoRun) this.onMeasureStopByAutoRun(data)
            if(this.onMeasureStopStatusBar) this.onMeasureStopStatusBar(data)
            this.setStopStatus()
            return true
        }

        await this.deviceMeasureStop()

        this.clearSendWork()
        this.clearEventWorker()

        if(this.isRunning){
            try {
                this.socket.emit('measure-stop',{
                    measureBit: 256,
                    measureTime: 180,
                    deviceSerial: this.deviceInfo.deviceSerial,
                    fileKey: this.fileKey,
                    force
                })
            } catch(e){
                console.error('[SocketProvider] measure-stop emit failed:', e)
            }
            this.isRunning = false
        }
    }

    /**
     * send message to socket server
     * @param msgType
     * @param msgData
     * @returns {boolean}
     */
    static sendMessages(msgType, msgData){
        try {
            this.socket.emit('messages',{
                msgType,
                msgData,
                device: this.deviceInfo
            })
            return true
        } catch(e) {
            console.log(e);
        }

        return false
    }

    /**
     * clear on event
     */
    static clearEvent(){
        this.onMeasure = null
        this.onMeasureStart = null
        this.onMeasureStop = null
        this.onMeasureTime = null

        this.onMeasureRequest = null
    }

    static async deviceMeasureStop(){
        try {
            await BridgeProvider.instance.deviceMeasureStop()
        } catch(e) {
            console.error('[SocketProvider] deviceMeasureStop failed:', e)
        }
    }

    static setStopStatus() {
        this.currentTime = 0
        this.startCheckTimer = null

        this.recvData.length = 0
        this.recvData = []

        this.sendData.length = 0
        this.sendData = []

        this.recvDataCount = 0
        this.sendDataCount = 0

        this.useEndMeasureOfQueue = false
        this.pause = false

    }
    static setMeasureOption(){
        const useHzTypes = ['eeg', 'default']
        if(-1 < useHzTypes.indexOf(this.requestMeasure.hzType)){
            this.useEndMeasureOfQueue = true
        }
    }

    static async checkStartMeasure(callback) {
        if(this.startCheckTimer){
            clearTimeout(this.startCheckTimer)
        }

        this.startCheckTimer = setTimeout(async() => {
            try {
                this.recvDate.getTime()
                return false
            } catch (e){}

            this.socket.emit('measure-start', this.requestMeasure)
            await this.checkStartMeasure()
            if(callback){
                callback('restart')
            }
        },5000)
    }

    static log(messageType, message) {
        this.socket.emit('log',{
            deviceSerial: this.deviceInfo.deviceSerial,
            messageType,
            message,
        })
    }

    /**
     * 시리얼포트 로그를 내부에서 추가합니다.
     * @param {string} message
     */
    static addSerialportLog(message) {
        const logEntry = {
            time: new Date().toLocaleTimeString(),
            message: message
        }
        this.serialportLogs.push(logEntry)
        if (this.serialportLogs.length > 200) {
            this.serialportLogs.shift()
        }
        if (this.onSerialportLog) {
            this.onSerialportLog(logEntry)
        }
    }

    static isConnected(){
        try {
            return this.socket.connected
        } catch (e){ return false}
    }


    /**
     * socket connect with set events
     * @param callback
     * @param window
     * @param hzType
     * @returns {Promise<void>}
     */
    static async connect(callback, window, hzType) {
        if(AuthProvider.isAppMode()) return 
        
        try {
            await this.deviceMeasureStop()
        } catch (e) {
            console.warn('[SocketProvider] connect deviceMeasureStop failed:', e)
        }

        await this.initDeviceEvent(window)
        this.deviceInfo = await this.checkDeviceStatus()
    
        if(!this.deviceInfo){
            this.addSerialportLog('[오류] 기기 정보를 찾을 수 없습니다.')
            // 최초 연결 이후에만 다이얼로그 표시 (프로그램 시작 시에는 표시 안 함)
            if(this.hasConnected) {
                GlobalAlertProvider.show('기기 정보를 찾을 수 없습니다.\n기기 연결 상태를 확인해 주세요.', '연결 오류')
            }
            try {
                this.socket.disconnect()
            } catch(e){
                console.warn('[SocketProvider] disconnect on no deviceInfo failed:', e)
            }
            this.socket = null
            return
        }

        this.measureHzType = hzType
        if(this.socket && this.socket.connected){
            try {
                callback()
            } catch (e) {
                this.addSerialportLog('[오류] 소켓 연결 처리 실패: ' + (e.message || e))
                GlobalAlertProvider.show('소켓 연결 처리 중 오류가 발생했습니다.\n다시 시도해 주세요.', '연결 오류')
            }
            return
        }

        this.startEventWorker()

        let socketHost =  process.env.REACT_APP_SOCKET_HOST
        if(process.env.NODE_ENV === 'development'){
            const res = await Axios.get(`/api/host-ip`)
            socketHost = `${res.data}:4001`
        }
        
        this.socket = socketIOClient(socketHost, {
            path: process.env.REACT_APP_SOCKET_PATH,
            transports: ['websocket'],
            query: {
                APPLICATION_TYPE: this.isBRHWService ? 'PC' : 'WEB' ,
                // VERSION: this.isBRHWService ? await window.BRHW.getVersion() : '-',
                VERSION: this.isBRHWService ? await BridgeProvider.instance.getVersion() : '-',
                ROOM_ID: this.deviceInfo.roomID,
                DEVICE_ID:  this.deviceInfo.deviceID,
                PROFILE_ID : this.deviceInfo.profileID,
                DEVICE_SERIAL : this.deviceInfo.deviceSerial
            }
        });

        // 기존 리스너 제거 (중복 등록 방지)
        this.socket.off('connected')
        this.socket.off('disconnect')
        this.socket.off('reconnect')
        this.socket.off('connect_error')
        this.socket.off('measure-queue')
        this.socket.off('measure-start')
        this.socket.off('measure-stop')
        this.socket.off('messages')

        this.socket.on('connected',()=>{
            this.hasConnected = true
            this.socket.emit('web-login' , this.deviceInfo)
            if(this.onConnect) this.onConnect()

            // 연결 성공 시 토스트 닫기
            if (this._disconnectSnackbarKey) {
                closeSnackbar(this._disconnectSnackbarKey)
                this._disconnectSnackbarKey = null
            }
        })

        this.socket.on('disconnect', () => {
            this._showDisconnectToast()
            if (this.onDisconnect) this.onDisconnect()
        })

        this.socket.on('connect_error', () => {
            this._showDisconnectToast()
        })

        this.socket.on('reconnect', () => {
            if (this._disconnectSnackbarKey) {
                closeSnackbar(this._disconnectSnackbarKey)
                this._disconnectSnackbarKey = null
            }
        })

        this.socket.on('measure-queue',(queue) => {
            // if(!this.isRunning){ return false }

            this.recvDataCount++
            this.recvDate = new Date()
            this.recvData.push(queue)
            // [PERF] 수신: 서버 결과가 도착한 간격 + 아직 소비 못한 수신 백로그
            //  recvGap ≈ 1000ms & backlog 낮음  → 서버/왕복 정상
            //  recvGap ≫ 1000ms                → 서버/왕복이 병목
            const _now = Date.now()
            const _recvGap = _now - (this._perfLastRecv || _now)
            this._perfLastRecv = _now
            if(_recvGap > 0) this.perfAdd(this.perf.recv, _recvGap)
            console.log(`[PERF][recv] recvGap=${_recvGap}ms recvBacklog=${this.recvData.length}`)
        })

        this.socket.on('measure-start',(data) => {
            if(this.onMeasureStart){
                this.onMeasureStart(data)
            }
        })

        this.socket.on('measure-stop',(data) => {
            // 새 측정이 이미 진행 중이면, 이전 측정의 지연된 stop 이벤트이므로 무시
            if(this.isRunning) {
                console.log(`[SocketProvider] 측정 진행 중 - 지연된 measure-stop 무시`)
                return
            }

            this.clearSendWork()
            this.clearEventWorker()

            // 누적 시간 업데이트 (lastMeasuredTime 사용 - setStopStatus 영향 안받음)
            this.accumulatedTime += this.lastMeasuredTime
            console.log(`[SocketProvider] measure-stop - lastMeasuredTime: ${this.lastMeasuredTime}, accumulated: ${this.accumulatedTime}, target: ${this.targetMeasureTime}`)

            // 사용자 강제 중지가 아니고, 부족한 시간이 있으면 자동 추가 측정
            if(!data.force && !this.isRetryMeasure) {
                const remainingTime = this.targetMeasureTime - this.accumulatedTime
                if(remainingTime > 1) {
                    console.log(`[SocketProvider] 부족한 시간 ${remainingTime}초 - 추가 측정 시작`)
                    this.isRetryMeasure = true

                    if(this.onAutoRetryMeasure) {
                        setTimeout(() => {
                            this.onAutoRetryMeasure(remainingTime)
                        }, 1000)
                    }
                    return
                }
            }

            // 정상 종료 처리
            this.isRetryMeasure = false
            this.accumulatedTime = 0
            this.lastMeasuredTime = 0

            if(this.onMeasureStop) this.onMeasureStop(data)
            if(this.onMeasureStopByAutoRun) this.onMeasureStopByAutoRun(data)
            if(this.onMeasureStopStatusBar) this.onMeasureStopStatusBar(data)

            this.setStopStatus()
        })

        this.socket.on('messages', (data) => {
            if(this.onMessages){
                this.onMessages(data)
            }
        })

        if(callback){
            callback(this.deviceInfo.status)
        }
    }


    static getMeasureLogID(){
        return this.measureLogID
    }

    // 로컬-우선: measureLogID 가 없어(소켓 ack 미수신) 운동 결과 저장은 fileKey(=업로드 sessionId)로 로그를 찾는다.
    static getFileKey(){
        return this.fileKey
    }

    static getRequestMeasure(){
        return this.requestMeasure
    }

    static _showDisconnectToast() {
        if (this._disconnectSnackbarKey) return
        if (window.location.pathname.indexOf('/manage/customer') > -1) return

        this._disconnectSnackbarKey = showSnackbar('측정 서버와 연결이 끊어졌습니다. 연결을 재시도 하고 있습니다.', {
            variant: 'warning',
            persist: true,
            anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
        })
    }

    static disconnect(){
        try {
            if (this._disconnectSnackbarKey) {
                closeSnackbar(this._disconnectSnackbarKey)
                this._disconnectSnackbarKey = null
            }
            this.clearSendWork()
            this.clearEventWorker()
            if (this.socket) {
                this.socket.off('disconnect')
                this.socket.off('connect_error')
                this.socket.off('reconnect')
                this.socket.disconnect()
            }
            this.socket = null
        } catch(e){
            console.error('[SocketProvider] disconnect failed:', e)
        }
    }
}
